







































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GlobalStore } from "@/stores/GlobalStore";
import { View } from "../Constants";

@Component
export default class Login extends Vue {
  @Prop(GlobalStore) readonly globalStore!: GlobalStore;
  private username = "";
  private password = "";
  private password2 = "";
  private isFailed = false;
  private isUserRegistered: null | boolean = null;

  get isInputValid(): boolean {
    return this.isUserValid && this.isPasswordValid;
  }

  get isUserValid(): boolean {
    const usernameRegex = /^[a-zA-Z0-9]+$/;
    return usernameRegex.test(this.username);
  }

  get isPasswordValid(): boolean {
    return this.password.length >= 6 && this.password.length < 20;
  }

  get arePasswordsEqual() {
    return this.password === this.password2;
  }

  get buttonText() {
    if (this.isUserRegistered === null) {
      return "Login / Register";
    } else if (this.isUserRegistered) {
      return "Login";
    }
    return "Register";
  }

  get isButtonDisabled() {
    return (
      !this.isInputValid || (!this.isUserRegistered && !this.arePasswordsEqual)
    );
  }

  async checkUser() {
    this.isUserRegistered = await this.globalStore
      .isRegistered(this.username)
      .then(success => {
        return success;
      })
      .catch(() => {
        return false;
      });
  }

  async loginOrRegister() {
    const isRegistered = await this.globalStore.isRegistered(this.username);
    let success = false;
    if (isRegistered) {
      //login
      success = await this.globalStore
        .login(this.username, this.password)
        .then(success => {
          return success;
        })
        .catch(() => {
          return false;
        });
    } else {
      //register
      success = await this.globalStore
        .registerUser(this.username, this.password)
        .then(success => {
          return success;
        })
        .catch(() => {
          return false;
        });
    }

    this.isFailed = !success;
  }
}
